var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"filterable":"","clearable":"","loading":_vm.loading},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(option){return _c('el-option',{key:option.value,attrs:{"value":option.value,"label":option.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }